import en from './en.json'

export const dictionaryList = { en };